module.exports = __webpack_public_path__ + "static/connections-2-64daea23b01d864cc88fef16b1ca85ca.jpg";